export const RICH_TEXT_INPUT_AREA_SIZE = {
  small: 'small',
  large: 'large',
} as const;

export const RICH_TEXT_INPUT_AREA_ACTION = {
  bold: 'bold',
  italic: 'italic',
  underline: 'underline',
  link: 'link',
  bulletedList: 'bulletedList',
  numberedList: 'numberedList',
} as const;
